module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/credits-small.b264a67a.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/credits-small.png
// module id = 2671
// module chunks = 11